<template>
  <div>
    <div
      class="bg-white shadow-sm py-3 my-2"
      style="border-radius: 10px"
      id="address_page"
    >
      <div v-if="has_undeletable_address" class="bg-warning text-dark pt-2 rounded mx-3 mb-4 pb-1">
        <div class="mb-2 px-4">{{ $t('validation.has_undeletable_address') }}</div>
        <ul>
          <li v-for="(address, index) in undeletable_address" :key="index" v-text="address" class="text-dark"></li>
        </ul>
      </div>

      <div class="d-flex align-items-center px-3">
        <div class="ml-auto">
          <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              fill="#00bea5"
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path
                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
            />
          </svg>
          <span class="pr-2">آدرس های من</span>
        </div>
        <div>
          <button
            type="button"
            class="btn btn-success px-4"
            style="border-radius: 10px"
            data-toggle="modal"
            data-target="#add_address_modal"
          >
            افزودن
          </button>
        </div>
      </div>
      <hr />
      <div class="px-2">
        <div class="table-responsive">
          <table class="table table-borderless text-center">
            <thead>
              <tr>
                <th
                  scope="col"
                  style="background-color: #eee; border-radius: 0 16px 16px 0"
                >
                  کد پستی
                </th>
                <th scope="col" style="background-color: #eee">آدرس</th>
                <th
                  scope="col"
                  style="background-color: #eee; border-radius: 16px 0 0 16px"
                >
                  عملیات
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(address, index) in addresses" :key="index">
                <td class="text-white-in-dark-mode" v-text="address.postal_code"></td>
                <td class="text-white-in-dark-mode" v-text="address.address"></td>
                <td>
                  <button
                    class="btn p-0 m-0 text-danger"
                    @click="deleteItem(index)"
                  >
                    <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm">
                      <span class="tooltip-text">حذف</span>
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#ff6060"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zM18 4h-2.5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"/></svg>
                      </span>
                    </span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal fade" id="add_address_modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-center">افزودن آدرس جدید</div>
            <form>
              <div class="form-group">
                <label for="add_address_modal_code" class="col-form-label"
                  >کد پستی</label
                >
                <input
                  type="text"
                  class="form-control"
                  dir="ltr"
                  id="add_address_modal_code"
                  v-model="new_postal_code"
                />
                <div class="my-2">
                    <p class="py-2 badge badge-danger">برای ثبت درگاه پرداخت پرداخت‌یاری کد پستی که وارد میکنید , همان کد پستی باشد که در سامانه مالیات معرفی کرده اید</p>
                </div>
              </div>
              <div class="form-group">
                <label for="add_address_modal_address" class="col-form-label"
                  >آدرس پستی</label
                >
                <textarea
                  class="form-control"
                  id="add_address_modal_address"
                  v-model="new_address"
                ></textarea>
              </div>
              <div class="d-flex justify-content-center">
                <button
                  type="button"
                  data-dismiss="modal"
                  @click="submitForm"
                  class="btn btn-success px-4"
                  style="border-radius: 10px"
                >
                  افزودن
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { addressService } from "@/common/api.service";
import $ from "jquery";
import Inputmask from "inputmask";

export default {
  name: "addresses",
  computed: {
    ...mapGetters("address", ["addresses"]),
  },
  mounted() {
    this.$store.dispatch("address/fetch");
    this.$store.dispatch("user/fetchCurrent");
    this.$nextTick(function () {
      setTimeout(() => {
        Inputmask("99999-99999").mask(
          document.querySelectorAll("#add_address_modal_code")
        );
      }, 1000);
    });
  },
  data() {
    return {
      has_undeletable_address: false,
      undeletable_address: null,
      new_address: "",
      new_postal_code: "",
    };
  },
  methods: {
    submitForm(e) {
      if (this.new_address == "" || this.new_postal_code == "") return;

      let params = this.addresses;

      params.push({
        id: 0,
        address: this.new_address,
        postal_code: this.new_postal_code,
      });

      this.new_address = "";
      this.new_postal_code = "";
      this.submitHelper(params);
    },
    deleteItem(index) {
      let params = this.addresses;

      if (params.length == 1) {
        let el = $("#address_page");
        this.showMsg(el, "danger", "حداقل یک آدرس مورد نیاز است.");
        return;
      }

      params.splice(index, 1);
      this.submitHelper(params);
    },
    submitHelper(params) {
      let el = $("#address_page");
      addressService
        .sync({ addresses: params })
        .then((response) => {
          this.showMsg(el, "success", response.data.message);

          if (response.data.data[0].undeletable_address != undefined) {
            this.undeletable_address = response.data.data[0].undeletable_address;
            this.has_undeletable_address = true;
          } else {
            this.has_undeletable_address = false;
            this.undeletable_address = null;
          }

          setTimeout(() => {
            this.$store.dispatch("address/fetch");
          }, 1000);
        })
        .catch(({ response }) => {
          this.showMsg(el, "danger", response.data.message);
        })
        .finally(() => {});
    },
  },
};
</script>

<style scoped>
</style>